import { parse } from 'qs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isInApp(query?: { [key: string]: any }): boolean {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query['os_type'] != null || query['app'] != null;
    }
    return false;
  }
  let triggered = false;
  triggered = sessionStorage['webviewTriggered'] === 'yes';
  const search = parse(location.search.slice(1));
  const isExpertCenterAndroid = search['pro_app'] != null && search['os_type'] === 'Android';
  if (
    !isExpertCenterAndroid && (
      triggered ||
      (search['os_type'] != null && search['os_type'] !== '') ||
      search['app'] != null
    )
  ) {
    sessionStorage['webviewTriggered'] = 'yes';
    return true;
  }
  return false;
}

export function isIOS(initialUserAgent = ''): boolean {
  const userAgent = typeof window !== 'undefined' ? navigator.userAgent : initialUserAgent;
  return /Mac|iPhone|iPad|iPod/i.test(userAgent);
}
